import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

const Projects = () => {
  const project_data = [
    {
      img: "/images/VECTOSENSELOGO.png",
      name: "Vecto Sence",
      role: "Full Stack Developer",
      descriptions:
        "Developed a responsive web application using React.js as part of the Vecto Sence project. The project involved designing and implementing a dynamic user interface, integrating back-end services, and ensuring cross-platform compatibility.",
    },
    {
      img: "/images/logo_white.png",
      name: "Legal Remit",
      role: "Front End Developer",
      descriptions:
        "Legal Remit was a critical project aimed at simplifying cross-border money transfers between Australia and Nepal through a secure and user-friendly banking solution. It addressed the challenges associated with international transactions and offered an efficient platform for users. As the lead developer for the admin panel of Legal Remit, I was responsible for implementing, and maintaining the entire administrative interface.",
    },
    {
      img: "/images/Focus Visa.png",
      name: "Focus Visa",
      role: "Front End Developer",
      descriptions:
        "Played a pivotal role in the development of the Focus Visa appointment booking application for flight related services. Demonstrated expertise in React.js, creating dynamic and user-friendly front-end interfaces that optimized user experiences for both projects. Collaborated with UI/UX designers to transform design mock-ups into interactive and responsive UI components, ensuring consistent aesthetics and usability.",
    },
    {
      img: "/images/final-logo-pride0102@2x.png",
      name: "Pride Motors",
      role: "Front End Developer",
      descriptions:
        "Developed a dynamic web application for selling and buying pre-owned cars, focusing on both admin and user functionalities. Designed and optimized RESTful APIs to manage real-time updates of car listings and transactions.",
    },
    {
      img: "/images/Meat_logo.png",
      name: "Meat Window",
      role: "Front End Developer",
      descriptions:
        "Meat Window is a comprehensive e-commerce platform focused on delivering a wide range of fresh, high-quality food and ready-to-eat products directly to consumers. This application provides a seamless shopping experience with features designed for user convenience and satisfaction, including a robust product catalog, a user-friendly add-to-cart functionality, and secure payment processing.",
    },
  ];

  const [showFullText, setShowFullText] = useState({});

  const toggleText = (index) => {
    setShowFullText((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="container-fluid d-flex align-items-center min-vh-100 bg-dark text-light">
      <div className="row justify-content-center w-100">
        <h1 className="mb-5 text-center">My Projects</h1>
        {project_data.map((project, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <Card
              className="bg-dark text-light"
              style={{
                width: "100%",
                border: "1px solid white",
              }}
            >
              <Card.Img
                variant="top"
                src={project.img}
                style={{
                  padding: "10px",
                  height: "180px",
                  objectFit: "contain",
                }}
              />
              <Card.Body className="d-flex flex-column">
                <Card.Title>{project.name}</Card.Title>
                <Card.Subtitle className="mb-2">{project.role}</Card.Subtitle>
                <Card.Text>
                  {showFullText[index]
                    ? project.descriptions
                    : `${project.descriptions.slice(0, 120)}...`}
                </Card.Text>
                <Button
                  variant="link"
                  className="text-primary mt-auto text-start"
                  onClick={() => toggleText(index)}
                >
                  {showFullText[index] ? "Read Less" : "Read More"}
                </Button>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
